import { motion } from "framer-motion";

export default function SpartanLoader({ className = "" }) {
  // Simple Spartan silhouettes marching
  const spartanCount = 3;
  return (
    <div className={`flex items-center justify-center gap-4 ${className}`}>
      {[...Array(spartanCount)].map((_, i) => (
        <motion.div
          key={i}
          animate={{
            y: [0, -10, 0],
            x: [0, 5, 0],
          }}
          transition={{
            repeat: Infinity,
            duration: 0.6,
            delay: i * 0.2,
            ease: "easeInOut",
          }}
          className="w-4 h-8 bg-gold rounded-t-lg"
        />
      ))}
      <motion.div 
        animate={{ opacity: [0.5, 1, 0.5] }}
        transition={{ repeat: Infinity, duration: 1.5 }}
        className="text-gold font-bold uppercase tracking-widest text-sm"
      >
        En marche...
      </motion.div>
    </div>
  );
}
